import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getEmpresas(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmpresasBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async getEmpresa(context, dados) {
        if (!JwtService.getToken()) throw new Error('Entre novamente no Desk.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("empresas/access/obter", {ID_EMPRESA: dados.id, componente: dados.componente});
        return data;
    },
	getEmpresaSimples(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/obterSimples", {ID_EMPRESA: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
	getEmpresaWeb(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/obterWeb", {ID_EMPRESA: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmpresaUsuarios(context, idEmpresa) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/obterUsuarios", idEmpresa).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteEmpresa(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresas/access/excluir", {ID_EMPRESA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async postEmpresa(context, empresa) {
        if (!JwtService.getToken()) throw new Error('Entre novamente no Desk.');
        ApiService.setHeader();
        try {
            const { data } = await ApiService.postOnce("empresas/access/salvar", empresa);
            return data;
        } catch {
            // Nao propagar objetos Axios que podem conter arquivos privados no corpo.
            return {resultado:false,msg:'A gravação não foi confirmada. Confira a listagem de empresas antes de repetir uma inclusão.'};
        }
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
